<template>
  <a-modal
    centered
    title="订单详情"
    v-model="visible"
    @cancel="visible = false"
    @ok="onSubmit"
    :maskClosable="false"
    width="700px"
    :confirmLoading="confirmLoading"
  >
    <div class="open-table-list item-box">
      <label>桌台：</label>
      <div
        v-for="item in openTableList"
        :key="item.TableId"
        class="open-table-item"
        @click="onSelected(item)"
        :class="[
          {
            checked: selectedKeys && selectedKeys.includes(item.TableId)
          }
        ]"
      >
        <div class="item-title tc">
          {{ item.TableName }}
        </div>
        <a-icon type="check" class="check-icon" />
      </div>
    </div>
    <div class="item-box">
      <label> {{ type == "returnFoods" ? "退菜数量" : "修改价格" }}：</label>
      <a-input-number
        v-model="Num"
        :min="minNum"
        :max="maxNum"
      ></a-input-number>
    </div>
    <div class="item-box" v-if="type == 'returnFoods'">
      <label> 原因：</label>
      <a-textarea v-model="Reason"></a-textarea>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      selectedKeys: [],
      Num: 1,
      currentInfo: {},
      minNum: 0,
      maxNum: 1,
      openTableList: [],
      type: "",
      Reason: "",
      confirmLoading: false
    };
  },
  // props: {
  //   openTableList: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  created() {},
  methods: {
    show(current, openTableList, type) {
      this.visible = true;
      this.currentInfo = current;
      this.type = type;
      this.confirmLoading = false;
      if (type == "returnFoods") {
        this.Num = 1;
        this.maxNum = this.currentInfo.Quantity;
        this.minNum = 1;
      } else if (type == "editPrice") {
        this.Num = this.currentInfo.UnitPrice;
        this.maxNum = 10000;
        this.minNum = 0;
      }
      this.openTableList = openTableList.filter(el => el.OrderStatus != 2);
      this.selectedKeys = this.openTableList.map(v => v.TableId);
    },
    onSelected(item) {
      const { selectedKeys } = this;
      if (selectedKeys.includes(item.TableId)) {
        this.selectedKeys = selectedKeys.filter(el => el != item.TableId);
      } else {
        this.selectedKeys.push(item.TableId);
      }
    },
    setLoadingStatus(status) {
      this.confirmLoading = status;
    },

    onSubmit() {
      let accountItemIds = [];
      this.openTableList.forEach(el => {
        if (this.selectedKeys.includes(el.TableId)) {
          const data = el.DishAccounts.filter(
            item =>
              item.BatchId == this.currentInfo.BatchId &&
              item.AccountItemId == this.currentInfo.AccountItemId
          );
          if (data && data.length) {
            const ids = data.map(v => v.Id);
            accountItemIds = accountItemIds.concat(ids);
          }
        }
      });
      if (this.selectedKeys && !this.selectedKeys.length) {
        this.$message.warning("请选择桌台");
        return false;
      }
      this.confirmLoading = true;
      this.$emit("submit", accountItemIds, this.Num, this.type, this.Reason);
      this.visible = false;
      // this.$post("ReturnDish", {
      //   AccountIds: accountItemIds,
      //   Num: -this.Num
      // }).then(res => {
      //   this.$message.success("操作成功");
      //   this.visible = false;
      //   this.$emit("update");
      // });
    }
  }
};
</script>

<style lang="less" scoped>
.item-box {
  display: flex;
  margin-bottom: 10px;
  & > label {
    min-width: 100px;
    text-align: right;
    font-size: 16px;
  }
}
.open-table-list {
  overflow: hidden;
  overflow-y: auto;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;

  .open-table-item {
    background-color: #fff;
    width: 160px;
    height: 50px;
    margin: 3px;
    border-radius: 2px;
    padding: 6px;
    cursor: pointer;
    float: left;
    border: 1px solid #ddd;
    .item-title {
      font-size: 18px;
      padding-top: 5px;
    }
    &:hover {
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    }
    .check-icon {
      display: none;
    }
    &.checked {
      border: 1px solid #f20;
      position: relative;
      &::after {
        content: "";
        width: 0;
        height: 0;
        border-bottom: 18px solid #f20;
        border-left: 20px solid transparent;
        position: absolute;
        bottom: 0;
        right: 0;
      }
      .check-icon {
        display: block;
        position: absolute;
        top: initial;
        bottom: 0;
        left: initial;
        right: 0;
        font-size: 10px;
        z-index: 10;
        color: #fff;
      }
    }
  }
}
.table-select-list {
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr;
  // grid-template-rows: auto;

  height: calc(100vh - 170px);

  .open-table-item {
    width: 31.3%;
    margin: 1%;
  }
}
</style>
